import jwtInterceptor from "./jwtInterceptor";
import {ELASTIC_ADDRESS_ENDPOINTS} from "../utils/api";

class AddressService {

    async searchAddress(searchQuery) {
        try {
            const response = await jwtInterceptor.post(ELASTIC_ADDRESS_ENDPOINTS.searchAddress, {
                q: searchQuery
            });
            return response.data.data;
        } catch (error) {
            throw new Error(error);
        }
    }
}

export const addressService = new AddressService();